import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function tiempoDesdeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || "").toString().trim();
    if (value === "" || value === "No quedan turnos disponibles") {
      return { tiempoDesdeInvalido: true };
    }
    return null;
  };


}

  export function notZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === "0" || control.value === 0) {
      return { notZero: true };
    }
    return null;
  }
}